<app-alert></app-alert>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>TERM SHEET - Library Data Entry</strong>
    </span>
    <!-- <span style="float:right">
      <a>
        <button class="btn btn-success pull-right" (click)="createNewField()" class="btn btn-sm btn-primary mb-2"
          type="button">
          <i class="fa fa-plus"></i>Create</button>
      </a>
    </span> -->
  </div>
  <section class="card search-box">
    <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
      <span class="pull-right">
        <i class="fa fa-filter" aria-hidden="true"></i>
      </span>
    </div>
    <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
      <div class="row">
        <div class="col-lg-12">
          <form>
            <div class="row">
              <div class="col-sm-2">
                <label class="form-control-label">Field Name :</label>
                <!-- </div>
              <div class="col-lg-2"> -->
                <div class="input-group">
                  <input type="text" class="form-control" [(ngModel)]="newFieldNameSearchParm" name="fieldSearch"
                    (keyup)="checkSearchFieldBlank()" />
                </div>
              </div>

              <div class="col-sm-2">
                <label>&nbsp;&nbsp;&nbsp;</label>
                <div class="input-group">
                  <button type="button" class="btn btn-sm btn-primary mb-2" (click)="doAdvSearchAction()">
                    <i class="fa fa-search"></i>&nbsp;Search</button>
                  &nbsp;&nbsp;&nbsp;
                  <button type="button" class="btn btn-sm btn-default mb-2" (click)="clearAdvSearch()">
                    <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>

  <div class="card-block datatable-card-block">
    <div class="row">
      <div class="col-md-12">
        <div class="margin-bottom-50">
          <div class="table-responsive">
            <table datatable [dtOptions]="dtFieldList" [dtTrigger]="dtTrigger"
              class="table table-hover compact cell-border nowrap stripe" id="termsheetTable" style="cursor: pointer;">
              <thead>
                <tr>
                  <th>Display No.</th>
                  <th>Field Name</th>
                  <th>First Line of default option</th>
                  <th>Display</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let termsheetDataList of termsheetDataListArray; let count=index"
                  style="line-height: 25px;">
                  <td>{{termsheetDataList.DisplayNo }}</td>
                  <td>{{termsheetDataList.FieldName}}</td>
                  <td>{{termsheetDataList.DefaultValue }}</td>
                  <td>{{termsheetDataList.Display }}</td>
                  <td>
                    <button type="button" class="btn-sm btn btn-warning" id="{{termsheetDataList._id}}"
                      data-target="#createNewFieldsId" data-toggle="modal" [appHasPermission]="{'Url': '/ncd-Library/edit', 'method':'put', 'menu': 'Term Sheet Library'}"
                      (click)="loadTermsheetByID(termsheetDataList._id);">
                      <span class="fa fa-pencil"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Modal -->
  <div class="modal fade" id="deleteTermsheetConfirmation" tabindex="-1" role="dialog" aria-labelledby=""
    aria-hidden="true" style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDelete">
            <i class="fa fa-question-circle-o mr-2"></i>Confirm</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-sm-12">
              Are you sure you want to delete Termsheet Field?
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-danger"  data-dismiss="modal">
            <i class="fa fa-check"></i>Yes
          </button>
          <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            <i class="fa fa-times"></i>No
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Create New Fields -->
  <div *ngIf="firstGetCall == true" class="modal fade" id="createNewFieldsId" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true"
    style="top: 50px;">
    <div class="modal-dialog" role="document">
      <div class="modal-content" style="width: 600px;">
        <div class="modal-header">
          <h5 class="modal-title" id="myModalLabelForDeletion">
            <i></i>Term Sheet Library Contents</h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="addNewTermsheetFieldForm" class="form-horizontal">
            <div class="form-group">
              <label class="control-label col-sm-3 float-left" for="display_no">Display No.</label>
              <div class="col-sm-9 float-left">
                <input type="text" class="form-control" id="display_no" placeholder="" name="display_no"
                  formControlName="displayNo" style="width: 110px;" (keydown)="onlyNumber($event)" readonly>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group" style="margin-top: 20px !important;">
              <label class="control-label col-sm-3 float-left" for="fieldName">Field Name</label>
              <div class="col-sm-9 float-left">
                <textarea class="form-control" id="fieldName" placeholder="" name="fieldName"
                  formControlName="fieldName" readonly></textarea>
              </div>
            </div>
            <div class="clearfix"></div>
            <div class="form-group clearfix">
              <div class="col-sm-offset-2 col-sm-10">
                <button class="btn btn-success pull-right" (click)="addNewFields()" class="btn btn-sm btn-primary mb-2"
                  type="button" style="margin-top: 25px;">
                  <i class="fa fa-plus"></i>&nbsp;Add</button>
              </div>
            </div>
            <div class="col-md-12 clearfix" formArrayName="newField" *ngFor="let a of newFieldArray; let i = index;">
              <div [formGroupName]="i">
                <tr style="line-height: 42px;">
                  <td tabindex="1" style="width:100% !important;">
                    <input type="hidden" formControlName="{{'staticValue'+ i}}"/>
                    <input
                      *ngIf="termsheetFieldById.InputType == 'Text' || termsheetFieldById.InputType == 'DropDownSelection' || termsheetFieldById.InputType == 'MultiSelectDropDown'"
                      type="text" class="form-control" name="{{'newFieldValue' + i }}" id="{{'newFieldValue' + i }}"
                      (keydown)="noBlankSpaceAtStart($event)" (keyup)="fieldValueChange(i)"
                      formControlName="{{'newFieldValue'+ i}}" />
                    <!-- NUMBER-->
                    <input *ngIf="termsheetFieldById.InputType == 'Number'" type="text" class="form-control"
                      name="{{'newFieldValue' + i }}" id="{{'newFieldValue' + i }}" (keyup)="fieldValueChange(i)"
                      (keydown)="onlyNumber($event)" formControlName="{{'newFieldValue'+ i}}" />

                    <!-- NUMBER WITHOUT ZERO-->
                    <input *ngIf="termsheetFieldById.InputType == 'NumberWithoutZero'" type="text" class="form-control"
                      name="{{'newFieldValue' + i }}" id="{{'newFieldValue' + i }}"
                      (keydown)="onlyNumberWithoutZero($event)" (keyup)="fieldValueChange(i)" formControlName="{{'newFieldValue'+ i}}" />
                  </td>
                  <td style='white-space: nowrap'>
                    <!-- <button type="button" class="btn-sm btn btn-warning" (click)="loadMeetingByMeetingID(meeting._id);"
                      style="margin-left: 11px;margin-right: -4px;">
                      <span class="fa fa-pencil"></span>
                    </button>&nbsp;&nbsp;&nbsp; -->
                    <button type="button" class="btn-sm btn btn-danger" (click)="removeField(i)"
                      style="margin-left: 11px;margin-right: -4px;">
                      <span class="icmn-bin"></span>
                    </button>
                    <input type="checkbox" id="{{'defaultSelect' + i}}" name="defaultValue"
                      formControlName="{{'defaultValue'+ i}}" style="width: 27px; height: 18px;" class="radioCheck"
                      (change)="deafultSelectChange($event, i)">
                    <label _ngcontent-c15="" for="{{'defaultSelect' + i}}"><span _ngcontent-c15=""
                        class="f-type-small"></span></label>
                  </td>
                </tr>
              </div>
            </div>

            <div *ngIf="termsheetFieldById?.FieldName != 'Debenture Trustee Email ID' && termsheetFieldById?.FieldName != 'Credit Rating Agency Name_1' && termsheetFieldById?.FieldName != 'Credit Rating Agency Name_2' && termsheetFieldById?.FieldName != 'Credit Rating Agency Name_3' && termsheetFieldById?.FieldName != 'Credit Rating Agency Name_4' && termsheetFieldById?.FieldName != 'Credit Rating Agency Address_1' && termsheetFieldById?.FieldName != 'Credit Rating Agency Address_2' && termsheetFieldById?.FieldName != 'Credit Rating Agency Address_3' && termsheetFieldById?.FieldName != 'Credit Rating Agency Address_4' && termsheetFieldById?.FieldName != 'Credit Rating_1' && termsheetFieldById?.FieldName != 'Credit Rating_2' && termsheetFieldById?.FieldName != 'Credit Rating_3' && termsheetFieldById?.FieldName != 'Credit Rating_4' && termsheetFieldById?.FieldName != 'Debenture Trustee Name' && termsheetFieldById?.FieldName != 'Debenture Trustee Address' && termsheetFieldById?.FieldName != 'Debenture Trustee Telephone Number' && termsheetFieldById?.FieldName != 'Debenture Trustee Website'" class="form-group clearfix" style="margin-top: 20px;">
              <label>Display: </label>&nbsp;
              <input type="radio" name="display" id="partADisplay" class="inp_style" value="Part A"
                formControlName="display" checked><span class="opt_name">Part A</span>
              <input type="radio" name="display" id="partBDisplay" class="inp_style" value="Part B"
                formControlName="display"><span class="opt_name">Part B</span>
              <input type="radio" name="display" id="noDisplay" class="inp_style" value="Neither"
                formControlName="display"><span class="opt_name">Neither</span>
            </div>

            <div *ngIf="termsheetFieldById?.FieldName == 'Debenture Trustee Email ID' || termsheetFieldById?.FieldName == 'Credit Rating Agency Name_1' || termsheetFieldById?.FieldName == 'Credit Rating Agency Name_2' || termsheetFieldById?.FieldName == 'Credit Rating Agency Name_3' || termsheetFieldById?.FieldName == 'Credit Rating Agency Name_4' || termsheetFieldById?.FieldName == 'Credit Rating Agency Address_1' || termsheetFieldById?.FieldName == 'Credit Rating Agency Address_2' || termsheetFieldById?.FieldName == 'Credit Rating Agency Address_3' || termsheetFieldById?.FieldName == 'Credit Rating Agency Address_4' || termsheetFieldById?.FieldName == 'Credit Rating_1' || termsheetFieldById?.FieldName == 'Credit Rating_2' || termsheetFieldById?.FieldName == 'Credit Rating_3' || termsheetFieldById?.FieldName == 'Credit Rating_4' || termsheetFieldById?.FieldName == 'Debenture Trustee Name' || termsheetFieldById?.FieldName == 'Debenture Trustee Address' || termsheetFieldById?.FieldName == 'Debenture Trustee Telephone Number' || termsheetFieldById?.FieldName == 'Debenture Trustee Website'" class="form-group clearfix" style="margin-top: 20px;">
              <label>Display: </label>&nbsp;
              <input type="radio" name="display" id="documentsDisplay" class="inp_style" value="Documents"
                formControlName="display" checked><span class="opt_name">Documents</span>
            </div>

          </form>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-sm btn-primary" (click)="updateTermsheetField()"  
            [disabled]="!addNewTermsheetFieldForm.valid || newFieldArray.length < 1 || disabledOnClick"  data-dismiss="modal">
            Update</button>
          <!-- <button type="button" class="btn btn-sm btn-primary" data-dismiss="modal">
            Update</button> -->
        </div>
      </div>
    </div>
  </div>
</section>